import { Card, CardContent, Typography, Stack, Box, Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import dayjs from 'dayjs';
import EventIcon from '@mui/icons-material/Event';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { MyVisit } from '@features/customer-reservations/api';

type MyVisitsListProps = {
  visits: MyVisit[];
};

export const MyVisitsList = ({ visits }: MyVisitsListProps) => {
  if (visits.length === 0) {
    return null;
  }

  return (
    <Stack spacing={2}>
      <Typography variant="h6" color="primary">
        <FormattedMessage
          id="customerAuth.myVisits.title"
          defaultMessage="Vaše naplánované návštěvy"
        />
      </Typography>

      {visits.map(visit => (
        <Card
          key={visit.id}
          sx={{
            borderLeft: 4,
            borderColor: visit.serviceColor || 'primary.main',
            bgcolor: 'grey.50',
          }}
        >
          <CardContent>
            <Stack spacing={1}>
              <Typography variant="subtitle1" fontWeight="medium" color="primary">
                {visit.serviceName}
              </Typography>

              <Stack direction="row" spacing={2} alignItems="center">
                <Box display="flex" alignItems="center" gap={0.5}>
                  <EventIcon fontSize="small" color="action" />
                  <Typography variant="body2" color="text.secondary">
                    {dayjs(visit.date).format('DD.MM.YYYY')}
                  </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={0.5}>
                  <AccessTimeIcon fontSize="small" color="action" />
                  <Typography variant="body2" color="text.secondary">
                    {dayjs(visit.date).format('HH:mm')} - {dayjs(visit.dateTo).format('HH:mm')}
                  </Typography>
                </Box>
              </Stack>

              {visit.services.length > 0 ? (
                <Typography variant="body2" color="text.secondary">
                  <FormattedMessage
                    id="customerAuth.myVisits.hairdresser"
                    defaultMessage="Služba: {serviceName}"
                    values={{ serviceName: visit.services.map(service => service.name).join(', ') }}
                  />
                </Typography>
              ) : null}
            </Stack>
          </CardContent>
        </Card>
      ))}

      <Alert severity="error" sx={{ fontSize: '0.875rem' }}>
        <FormattedMessage id="customerAuth.myVisits.cancelInfo" />
      </Alert>
    </Stack>
  );
};
